import ActiveMusclesPieChart from './ActiveMusclesPieChart';

export default ActiveMusclesPieChart;
